document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-card__image-slider').forEach((slider, sliderIdx) => {
    const slides = slider.querySelectorAll('.product-card__image--slide');
    const dots = slider.parentElement.querySelectorAll('.slider-dot');

    const count = slides.length;
    if (count <= 1) return;

    let currentIndex = 0;
    let touchStartX = 0;
    let autoScrollInterval = null;
    const isMobile = window.innerWidth < 768;

    // Initialize classes: replace 'hidden' with proper slide classes
    slides.forEach((slide, i) => {
      slide.classList.remove('hidden');
      if (i === 0) {
        slide.classList.add('slide-active');
      } else {
        slide.classList.add('slide-hidden');
      }
    });

    const goToSlide = (index) => {
      if (index === currentIndex) return;
      slides[currentIndex].classList.replace('slide-active', 'slide-hidden');
      dots[currentIndex]?.classList.remove('active');
      currentIndex = index;
      slides[currentIndex].classList.replace('slide-hidden', 'slide-active');
      dots[currentIndex]?.classList.add('active');
    };

    dots.forEach((dot, index) => dot.addEventListener('click', () => goToSlide(index)));

    slider.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    slider.addEventListener('touchend', (e) => {
      const diff = touchStartX - e.changedTouches[0].screenX;
      const direction = Math.sign(diff);
      if (Math.abs(diff) > 30) goToSlide((currentIndex + direction + count) % count);
    }, { passive: true });

    // Desktop-only hover auto-scroll
    if (!isMobile) {
      const startAutoScroll = () => {
        if (autoScrollInterval) clearInterval(autoScrollInterval);
        autoScrollInterval = setInterval(() => {
          goToSlide((currentIndex + 1) % count);
        }, 1200);
      };

      const stopAutoScroll = () => {
        if (autoScrollInterval) {
          clearInterval(autoScrollInterval);
          autoScrollInterval = null;
        }
      };

      slider.addEventListener('mouseenter', startAutoScroll);
      slider.addEventListener('mouseleave', stopAutoScroll);
    }
  });
});

